import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../api';

// Thunk to fetch users by email
export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async (email, { rejectWithValue }) => {
    try {
      const response = await api.post('/users', { email });
      return response.data; // expected to return user(s) info
    } catch (error) {
      return rejectWithValue(error.response?.statusText || error.message);
    }
  }
);

const usersSlice = createSlice({
  name: 'users',
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload; // set the fetched users
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default usersSlice.reducer;
